import React, { type CSSProperties, type ChangeEvent } from 'react';
import {
  Input,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
} from 'js/ui/legacy';
import NumberInput from '../../mylib/NumberInput';
import { rightToLeft } from '../../mylib/Utils';

type SliderWithValueProps = {
  value: number;
  setValue: (value: number) => void;
  offset?: number;
};

export const SliderWithValue = ({
  value,
  setValue,
  offset = 0,
}: SliderWithValueProps) => {
  const in_range = value >= -50 && value <= 50;
  const isRtl = rightToLeft();
  const direction: CSSProperties['direction'] = isRtl ? 'rtl' : 'ltr';
  const inputStyle: CSSProperties = {
    direction: 'ltr',
    textAlign: isRtl ? 'right' : 'left',
    borderRadius: isRtl ? '0 0.25rem 0.25rem 0' : '0.25rem 0 0 0.25rem',
  };
  const addonStyle: CSSProperties = {
    borderRadius: isRtl ? '0.25rem 0 0 0.25rem' : '0 0.25rem 0.25rem 0',
  };
  const addonType = isRtl ? 'prepend' : 'append';
  const rangeStyle: CSSProperties = {
    opacity: in_range ? 1 : 0,
    direction,
  };
  return (
    <div
      className={'pl-2 pr-2'}
      style={{ display: 'inline-flex', width: '100%' }}
      dir={direction}
    >
      <Input
        className={'pl-2 pr-2'}
        style={rangeStyle}
        dir={direction}
        type="range"
        name="range"
        min={-50 + offset}
        max={50 + offset}
        value={value + offset}
        onChange={(event: ChangeEvent<HTMLInputElement>) => {
          if (in_range) {
            setValue(parseFloat(event.target.value) - offset);
          }
        }}
        id="exampleRange"
      />
      <InputGroup style={{ direction }}>
        {!isRtl && (
          <InputGroupAddon addonType={addonType}>
            <InputGroupText style={addonStyle}>%</InputGroupText>
          </InputGroupAddon>
        )}
        <NumberInput
          id={'scale_frm_input'}
          className="form-control"
          min={-99 + offset}
          value={value + offset}
          onChange={(newValue: number) => setValue(newValue - offset)}
          style={inputStyle}
        />
        {isRtl && (
          <InputGroupAddon addonType={addonType}>
            <InputGroupText style={addonStyle}>%</InputGroupText>
          </InputGroupAddon>
        )}
      </InputGroup>
    </div>
  );
};
